import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { SelectableOption } from '../filter.component';
import { TranslatePipe } from '@ngx-translate/core';
import { MultiCheckboxComponent } from '../../../multi-checkbox/multi-checkbox.component';
import { FilterOptionComponent } from '../../filter-option/filter-option.component';

@Component({
  selector: 'app-filter-utilization',
  templateUrl: './filter-utilization.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FilterOptionComponent, MultiCheckboxComponent, TranslatePipe],
})
export class FilterUtilizationComponent {
  @Input() utilizationOptions: SelectableOption[] = [];

  @Output() apply = new EventEmitter();
  @Output() back = new EventEmitter();
  @Output() optionChange: EventEmitter<SelectableOption[]> = new EventEmitter<SelectableOption[]>();

  onApply() {
    this.apply.emit();
  }

  onBack() {
    this.back.emit();
  }

  onOptionChange(event: SelectableOption[]) {
    this.optionChange.emit(event);
  }
}
